/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ExpirePaymentResponseDto
 */
export interface ExpirePaymentResponseDto {
    /**
     * Participation ID
     * @type {string}
     * @memberof ExpirePaymentResponseDto
     */
    'participationId': string;
    /**
     * Updated payment status
     * @type {string}
     * @memberof ExpirePaymentResponseDto
     */
    'paymentStatus': ExpirePaymentResponseDtoPaymentStatusEnum;
    /**
     * Success message
     * @type {string}
     * @memberof ExpirePaymentResponseDto
     */
    'message': string;
}

export const ExpirePaymentResponseDtoPaymentStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;

export type ExpirePaymentResponseDtoPaymentStatusEnum = typeof ExpirePaymentResponseDtoPaymentStatusEnum[keyof typeof ExpirePaymentResponseDtoPaymentStatusEnum];


